import { useFormContext } from "react-hook-form";
import Checkbox from "@/components/Checkbox/Checkbox";
import { useLingui } from "@lingui/react/macro";

export type HomeCareCheckboxFields = {
  homeCare: boolean;
};

const HomeCareCheckbox = () => {
  const { register } = useFormContext<HomeCareCheckboxFields>();
  const { t } = useLingui();

  return <Checkbox label={{ text: t`Hemtjänst` }} {...register("homeCare")} />;
};

export default HomeCareCheckbox;
